import { createClient } from "@pankod/refine-supabase";

// const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL | "";
// @ts-ignore-next-line
// const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL | "https://wqdnystulyspzjmrhafv.supabase.co";
// const SUPABASE_URL = "https://kks-api.bbox.kiev.ua";
//const SUPABASE_URL = "https://api.oceanplaza.com.ua";
const SUPABASE_URL = "http://192.168.100.5";
// const SUPABASE_URL = "https://wqdnystulyspzjmrhafv.supabase.co";
const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndxZG55c3R1bHlzcHpqbXJoYWZ2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NjEwMjEwMDUsImV4cCI6MTk3NjU5NzAwNX0.9OKvrbiawsoMtXz3EppWpKNQUdK31UxPz9oRpxYEtAQ";
// const SUPABASE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndxZG55c3R1bHlzcHpqbXJoYWZ2Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTY2MTAyMTAwNSwiZXhwIjoxOTc2NTk3MDA1fQ.SiOgC3D3zRSh7jbO2-8oyayaeADkugOXT0TZzkfKMUI";

// @ts-ignore-next-line
export const supabaseClient = createClient(SUPABASE_URL, SUPABASE_KEY);
